document.addEventListener("DOMContentLoaded", function () {
  const tabLinks = document.querySelectorAll(".tab-link");
  const tabContents = document.querySelectorAll(".tab-content");

  tabLinks.forEach((link) => {
    link.addEventListener("click", function () {
      // Remove active class from all links and contents
      tabLinks.forEach((link) => link.classList.remove("active"));
      tabContents.forEach((content) => content.classList.remove("active"));

      // Add active class to clicked link and corresponding content
      this.classList.add("active");
      const tabId = this.getAttribute("data-tab");
      document.getElementById(tabId).classList.add("active");
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  // Your existing tab code here...

  // CUSTOM CODE FOR STARS CLICK
  const stars = document.querySelector(".jdgm-prev-badge"); // Adjust selector if needed
  // The data-tab attribute value for your Reviews tab
  const reviewsTabLink = document.querySelector('.tab-link[data-tab="tab-reviews"]');
  const reviewsTabContent = document.getElementById("tab-reviews");

  if (stars && reviewsTabLink && reviewsTabContent) {
    stars.addEventListener("click", function (e) {
      e.preventDefault();

      // Deactivate all tabs
      document.querySelectorAll(".tab-link").forEach(link => link.classList.remove("active"));
      document.querySelectorAll(".tab-content").forEach(content => content.classList.remove("active"));

      // Activate Reviews tab and content
      reviewsTabLink.classList.add("active");
      reviewsTabContent.classList.add("active");

      // Scroll smoothly to the Reviews tab section
      reviewsTabLink.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }
});
